class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.cartTimer = this.querySelector("cart-timer");

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLinks = document.querySelectorAll(
      "header #cart-icon-bubble, #cart-icon-bubble-mobile"
    );

    cartLinks.forEach((cartLink) => {
      cartLink.setAttribute("role", "button");
      cartLink.setAttribute("aria-haspopup", "dialog");

      cartLink.addEventListener("click", (event) => {
        event.preventDefault();
        if (cartLink.id === "cart-icon-bubble-mobile") {
          const headerDrawer = document.querySelector("header-drawer");
          const menuDrawers = document.querySelectorAll(".drawer-pages");

          menuDrawers.forEach(function (drawer) {
            const menuDrawerWrapper = drawer.closest(
              ".dynamic-mobile-drawer-menu"
            );

            setTimeout(() => {
              menuDrawerWrapper?.classList.remove("open-drawer");
              document.body.classList.remove("menu-open");
              drawer
                ?.querySelectorAll("details[open]")
                .forEach(function (detail) {
                  drawer?.closeSubmenu(detail);
                });
              headerDrawer?.closeMenuDrawer(event);
            }, 300);
          });
        }
        this.open(cartLink);
      });
    });
  }

  open(triggeredBy) {
    /* Start customizations "enhanced-datalayer" */
    document.dispatchEvent(
      new CustomEvent("cart-open", {
        bubbles: true,
        cancelable: true
      })
    );
    /* End customizations "enhanced-datalayer" */

    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelectorAll(section.selector)
        : [document.getElementById(section.id)];

      let sectionId = section.id;

      if (
        !parsedState.sections[sectionId] &&
        sectionId === "cart-drawer" &&
        parsedState.sections["no-gift-cart-drawer"]
      ) {
        sectionId = "no-gift-cart-drawer";
      }

      Array.from(sectionElement).forEach(
        (item) =>
          (item.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[sectionId],
            section.selector
          ))
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer"
      },
      {
        id: "cart-icon-bubble",
        selector: ".cart-icon-bubble"
      }
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  productAddedToCart() {
    if (this.cartTimer) this.cartTimer.productAddedToCart();
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "no-gift-cart-drawer",
        selector: ".drawer__inner"
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section"
      }
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);

class CartGift extends CartDrawerItems {
  constructor() {
    super();

    const giftButton = this.querySelector(".cart__gift-add-button");
    this.cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    if (giftButton) {
      giftButton.addEventListener("click", () => {
        console.log("gift add");
        this.addGiftToCart(giftButton.dataset.variantId, 1);
      });
    }
  }

  addGiftToCart(id, quantity) {
    /* Start customizations "enhanced-datalayer" */
    /* we need to send default formData like in product-form.js to get a more rich response */
    /* seems like a bug from Shopify, because based on the content-type of the request the result is differently */
    const config = fetchConfig("javascript");
    const formData = new FormData();

    formData.append("id", id);
    formData.append("quantity", quantity);
    formData.append("properties[_free_gift]", "cart_gift");
    formData.append(
      "sections",
      this.getSectionsToRender()
        .map((section) => section.section)
        .join(",")
    );
    formData.append("sections_url", window.location.pathname);

    config.body = formData;
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];
    /* End customizations "enhanced-datalayer" */

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartFooter = document.getElementById("main-cart-footer");
        this.cart.renderContents(parsedState);

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-items",
          cartData: parsedState,
          variantId: id
        });

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-items",
          cartData: parsedState,
          variantId: id
        });

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
      })
      .catch((e) => {
        console.log(e);
        document.getElementById("cart-errors").textContent =
          window.cartStrings.error;
      });
  }
}

customElements.define("cart-gift", CartGift);

class DrawerUpsell extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      observer.unobserve(this);
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("drawer-upsell");
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
          if (html.querySelector(".grid__item")) {
            this.classList.add("drawer-upsell--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px"
    }).observe(this);
  }
}

customElements.define("drawer-upsell", DrawerUpsell);
